import styled from 'styled-components';

export const Container = styled.div`
  max-width: 24rem;
  padding: 1.2rem;
  background: ${({ theme }) => theme.backgroundSecondary};
  border-radius: 8px;
  letter-spacing: 0.84px;
`;
